import { render, staticRenderFns } from "./BeneficiaryInformation.vue?vue&type=template&id=54afeea0&scoped=true"
import script from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afeea0",
  null
  
)

export default component.exports